"use client";

import { Link as ChakraLink } from "@chakra-ui/next-js";
import { useSearchParams } from "next/navigation";
import { ComponentProps } from "react";

/**
 * Link component that automatically preserves the `eid` query parameter
 *
 * IMPORTANT: Only use for INTERNAL routes within your app.
 */
export default function PersistParamsLink({ href, ...props }: ComponentProps<typeof ChakraLink>) {
  const searchParams = useSearchParams();
  const eid = searchParams.get("eid");

  // Build the URL with eid if it exists
  const buildHref = () => {
    if (typeof href !== "string") {
      // If href is an object (UrlObject), return as-is
      return href;
    }

    // If no eid, return href as-is
    if (!eid) {
      return href;
    }

    // Parse the href to check if it already has query params
    const [path, existingQuery] = href.split("?");
    const params = new URLSearchParams(existingQuery);

    // Add eid if not already present
    if (!params.has("eid")) {
      params.set("eid", eid);
    }

    // Rebuild the URL
    const queryString = params.toString();
    return queryString ? `${path}?${queryString}` : path;
  };

  return <ChakraLink href={buildHref()} {...props} />;
}
